<ng-container>
    <a target="_blank" (click)="openChatBox($event)"> <img class="w-[20px] h-[20px]" src="../../../../assets/images/help-center-icon.svg" /></a>
</ng-container>